// ----------------------------------------------------------------------
export var Autocomplete = function Autocomplete(_ref) {
  var theme = _ref.theme;
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          boxShadow: theme.shadows[25].z20
        }
      }
    }
  };
};